import { render } from "./ImgImage.vue?vue&type=template&id=3d2d7156&scoped=true"
import script from "./ImgImage.vue?vue&type=script&lang=js"
export * from "./ImgImage.vue?vue&type=script&lang=js"

import "./ImgImage.vue?vue&type=style&index=0&id=3d2d7156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2d7156"]])

export default __exports__